export const BUTTON_EXIT_CODE = 35; // end
export const BUTTON_OK_CODE = 13; // enter
export const BUTTON_SPACE_CODE = 32; // space
export const BUTTON_ESC_CODE = 27; // esc
export const BUTTON_BACK_CODE = 8; // Backspace
export const BUTTON_TAB_CODE = 9; // Tab
export const BUTTON_HOME_CODE = 36; // home

export const BUTTON_A_CODE = 65; // A character
export const BUTTON_Z_CODE = 90; // Z button

export const BUTTON_LEFT_ARROW_CODE = 37;
export const BUTTON_RIGHT_ARROW_CODE = 39;
export const BUTTON_UP_ARROW_CODE = 38;
export const BUTTON_DOWN_ARROW_CODE = 40;

export const BUTTON_CHANNEL_UP_CODE = 107; // The + key in a num pad
export const BUTTON_CHANNEL_DOWN_CODE = 109; // The - key in a num pad

export const BUTTON_PREVIOUS_CODE = 80; // 'p'

export const BUTTON_ENTER_KEY_CODE = 13; // The Enter or Return key
